"use client"

import { Checkbox, Input } from "@/components/atoms"
import { Accordion, FilterCheckboxOption } from "@/components/molecules"
import useFilters from "@/hooks/useFilters"
import useUpdateSearchParams from "@/hooks/useUpdateSearchParams"
import { ArrowLongDown, ArrowLongUp } from "@medusajs/icons"
import { useTranslate } from "@tolgee/react"
import { useSearchParams } from "next/navigation"
import React, { useEffect, useState } from "react"
import { filterCondition, sortOptions } from "./MeiliSideBarOptions"
export const MeilisearchProductSidebar = () => {

    return <div>
        <div className="*:mb-4 hidden md:block sticky top-4">
            <PriceFilter />
            <SortOption />
            <ConditionFilter />
        </div>

        <div className="*:mb-4 md:hidden">
            <PriceFilter defaultOpen={false} />
            <SortOption defaultOpen={false} />
            <ConditionFilter defaultOpen={false}/>
        </div>

    </div>
}

function SortOption({ defaultOpen = true }: { defaultOpen?: boolean }) {
    const { t } = useTranslate();
    const searchParams = useSearchParams()
    let [sortData, setSortData] = useState<string[]>([])
    let [lable, value] = sortData;
    const updateSearchParams = useUpdateSearchParams()

    useEffect(() => {
        let sort = searchParams.get("sortBy") || "sales:desc"
        setSortData(sort.split(":"))
    }, [searchParams])

    const setSort = (fileds: string) => {
        let setValue;
        if (fileds === lable) {
            switch (value) {
                case "asc":
                    setValue = "desc"
                    break;
                case "desc":
                    setValue = "asc"
                    break;
                default:
                    setValue = "desc"
                    break;
            }
        } else {
            setValue = "desc"
        }
        updateSearchParams("sortBy", fileds + ":" + setValue)
    }


    return (
        <Accordion heading={t("filters.sort")} defaultOpen={defaultOpen}>
            <div className="*:p-2 *:py-3 *:border-b">
                {sortOptions.map(o => {
                    let status;
                    if (o.sortFields === lable) {
                        status = value
                    }
                    return <div key={o.sortFields} className="last:border-none flex justify-between items-center cursor-pointer" onClick={() => setSort(o.sortFields)}>
                        {o.label}
                        <div className="flex text-gray-400">
                            <ArrowLongUp className={status === "asc" ? "text-black" : ""} />
                            <ArrowLongDown className={status === "desc" ? "text-black" : ""} />
                        </div>
                    </div>
                })}
            </div>
        </Accordion>
    )
}


function PriceFilter({ defaultOpen = true }: { defaultOpen?: boolean }) {
    const { t } = useTranslate();
    const [min, setMin] = useState("")
    const [max, setMax] = useState("")

    const updateSearchParams = useUpdateSearchParams()
    const searchParams = useSearchParams()

    useEffect(() => {
        setMin(searchParams.get("min_price") || "")
        setMax(searchParams.get("max_price") || "")
    }, [searchParams])

    const priceChangeHandler = (field: string, value: string) => {
        const reg = new RegExp("^[0-9]+$")
        if (reg.test(value) || value === "") {
            if (field === "min") setMin(value)
            if (field === "max") setMax(value)
        }
    }

    const updateMinPriceHandler = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        updateSearchParams("min_price", min)
    }

    const updateMaxPriceHandler = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        updateSearchParams("max_price", max)
    }
    return (
        <Accordion heading={t("price_filter.heading")} defaultOpen={defaultOpen}>
            <div className="flex gap-2 mb-4">
                <form method="POST" onSubmit={updateMinPriceHandler}>
                    <Input
                        placeholder={t("price_filter.min_placeholder")}
                        onChange={(e) => priceChangeHandler("min", e.target.value)}
                        value={min}
                        onBlur={(e) => {
                            updateMinPriceHandler(
                                e as unknown as React.FormEvent<HTMLFormElement>
                            )
                        }}
                    />
                    <input type="submit" className="hidden" />
                </form>
                <form method="POST" onSubmit={updateMaxPriceHandler}>
                    <Input
                        placeholder={t("price_filter.max_placeholder")}
                        onChange={(e) => priceChangeHandler("max", e.target.value)}
                        onBlur={(e) => {
                            updateMaxPriceHandler(
                                e as unknown as React.FormEvent<HTMLFormElement>
                            )
                        }}
                        value={max}
                    />
                    <input type="submit" className="hidden" />
                </form>
            </div>
        </Accordion>
    )
}

function ConditionFilter({ defaultOpen = true }: { defaultOpen?: boolean }) {
    const { t } = useTranslate();
    const { updateFilters, isFilterActive } = useFilters("condition")

    return (
        <Accordion heading={t("filters.condition_heading")} defaultOpen={defaultOpen}>
            <div className="px-2">
                {filterCondition.map((v) => {
                    return <div key={v.label} className="flex gap-2">
                        <Checkbox checked={isFilterActive(v.label)} onClick={() => {
                            updateFilters(v.label)
                        }} />
                        {v.label}
                    </div>
                })}
            </div>
        </Accordion>
    )
}